<template>
	<div class="bright container-fluid py-3">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="!isChildRoute">
			<div class="col-md-12 mb-2">
				<h4>OVERVIEW LPG</h4>
			</div>

			<div class="col-md-9">
				<div class="row">
					<div class="col-md-4">
						<ListCompare title="SALES TOTAL" unit="B" :data="ytd.sales.rekap" itemcol="Info" valuecol="Value" url="/lpg/report"/>
					</div>
					<div class="col-md-4">
						<ListCompare title="SALES PSO" unit="B" :data="ytd.sales.pso" itemcol="Info" valuecol="Value" url="/lpg/report"/>
					</div>
					<div class="col-md-4">
						<ListCompare title="SALES NON PSO" unit="B" :data="ytd.sales.nonpso" itemcol="Info" valuecol="Value" url="/lpg/report"/>
					</div>
				</div>
				<div class="row">
					<div class="col-md-6">
						<BarCard title="SALES YTD (B)" :data="ytd.sales.ytdchart" :width="500" :height="280" url="/lpg/report"/>
					</div>
					<div class="col-md-6">
						<BarCard title="SALES MTD (B)" :data="ytd.sales.mtdchart" :width="500" :height="280" url="/lpg/report"/>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
					<BarCard title="SALES MONTHLY (B)" :data="monthly.sales" :width="500" :height="280" url="/lpg/report"/>
					</div>
				</div>
			</div>

			<div class="col-md-3">
				<div class="row">
					<div class="col-md-12">
					<ListItem title="NO OF AGENTS" :data="keagenan.province" itemcol="ProvinceName" valuecol="StoreCnt" url="/lpg/keagenan"/>
					</div>
				</div>
			</div>
		</div>
		<Footer/>
	</div>
</template>

<script>
import LPG from '@/components/page/LPG.js'
import BarCard from '@/views/pages/BarCard.vue'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Footer from '@/views/Footer.vue'

export default{
	extends: LPG,
	components:{
		ListItem,
		ListCompare,
		BarCard,
		Footer
	},
    data() {
		return {
            isChildRoute: false,
        }
    },
    mounted(){
        this.hideNonChildren();
		this.loadYTD();
		this.loadKeagenan();
		this.loadSales();
    },
    watch: {
        $route(to, from) {
            this.hideNonChildren();
        }
    },
    methods:{
        hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/lpg';
        },
	},
}

</script>
